import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import instance from "../../instance/AxiosInstance";
import Style from "./index.module.css";
import LoadingSpin from "react-loading-spin";
import { toast } from "react-toastify";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import Google from "../../Assets/Icons/Google"
import { UserContext } from "../../Contexts/UserContext";
import { AdminContext } from "../../Contexts/AdminContext";
import NotificationToggle from "../Notification_Permission/NotificationToggle";

const MobileSignup = ({ setLogin }) => {
    const { t } = useTranslation();
   const {showMessage} = useContext(UserContext)
    //authentication option
    const [otp, setOtp] = useState(false);
    const [passwordToggle, setPasswordToggle] = useState(false);
    const [loading, setLoading] = useState(false);
    const [responseError, setResponseError] = useState("");
    const [ShowPassword, SetShowPassword] = useState(false);
    const [ShowConfirmPassword, SetShowConfirmPassword] = useState(false);

    const [Step, SetStep] = useState(0);
    const [Timer, SetTimer] = useState(60);
    const [IsTimerRunning, SetIsTimerRunning] = useState(false);

    // Function to toggle password visibility
    const togglePasswordVisibility = () => {
        SetShowPassword(!ShowPassword);
    };

    // Function to toggle confirm password visibility
    const toggleConfirmPasswordVisibility = () => {
        SetShowConfirmPassword(!ShowConfirmPassword);
    };


    const [otpDetails, setOtpDetails] = useState({
        phoneNumber: "",
        otp: "",
    });

    //States

    const [formError, setFormError] = useState(false);

    const [error, setError] = useState({
        password: "",
        confirmPassword: "",
        phoneNumber: "",
        otp: "",
    });

    const [phoneNumber, setPhoneNumber] = useState("")
    const [password, setPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")
    const [userData, setUserData] = useState("")
    const [username, setUsername] = useState("");
    const [privacyPermission,setPrivacyPermission] = useState(false)

    const navigate = useNavigate();

    const loggedInUser = useContext(UserContext);
    const { SetUser } = loggedInUser;

    const loggedInAdmin = useContext(AdminContext);
    const { SetAdmin } = loggedInAdmin || {};


    // -- To set Otp into the state
    const otpHandler = (e) => {
        setOtpDetails((prevDetails) => ({
            ...prevDetails,
            phoneNumber,
            otp: e.target.value,
        }));
    };
    console.log(otpDetails);

    // -- Function to set timer to resend the Otp
    useEffect(() => {
        let interval;

        if (IsTimerRunning && Timer > 0) {
            interval = setInterval(() => {
                SetTimer((prevTimer) => prevTimer - 1);
            }, 1000);
        } else if (Timer === 0) {
            SetIsTimerRunning(false);
            SetTimer(60); // Reset timer
        }

        return () => {
            clearInterval(interval);
        };
    }, [IsTimerRunning, Timer]);

    // -- From validations




    const phone_validation = (e) => {
        if (e.target.value !== "") {
            setFormError(false);
            if (e.target.value.toString().length < 10) {
                setFormError(true);
                setError({ ...error, phoneNumber: "Phonenumber must have 10 digits" });
            } else {
                setFormError(false);
                setPhoneNumber(e.target.value);
                setError({ ...error, phoneNumber: "" });
                return true;
            }
        } else {
            setFormError(true);
            setError({ ...error, phoneNumber: "This field cannot be empty" });
            setTimeout(() => {
                setError({ ...error, phoneNumber: "" });
            }, 5000);
            return false;
        }
    };



    const password_validation = (e) => {
        if (e.target.value !== "") {
            setFormError(true);
            if (e.target.value.replace(/ /g, "").length <= 8) {
                setError({ ...error, password: "Minimum 8 character needed" });
                return false;
            } else {
                setFormError(false);
                setError({ ...error, password: "" });
                setPassword(e.target.value);
                return true;
            }
        } else {
            setFormError(true);
            setError({ ...error, password: "Field can't be empty" });
            setTimeout(() => {
                setError({ ...error, password: "" });
            }, 5000);
            return false;
        }
    };

    const confirmPassword_validation = (e) => {
        const confirmPass = e.target.value.trim();
        setConfirmPassword(confirmPass);

        if (confirmPass === "") {
            setFormError(true);
            setError((prev) => ({ ...prev, confirmPassword: "Field can't be empty" }));

            setTimeout(() => {
                setError((prev) => ({ ...prev, confirmPassword: "" }));
            }, 5000);
            return false;
        }

        if (confirmPass !== password) {
            setFormError(true);
            setError((prev) => ({ ...prev, confirmPassword: "Enter Correct password" }));
            return false;
        }

        // ✅ If the confirm password is correct
        setFormError(false);
        setError((prev) => ({ ...prev, confirmPassword: "" }));
        return true;
    };

    // -- Submit handler for otp G
    const submitHandler = (e) => {
        setResponseError("");
        e.preventDefault();
        if (formError) {
            console.log("enter proper details");
        } else {
            setLoading(true);


            instance
                .post("/api/mobilephoneotp", { phoneNumber })
                .then((response) => {


                    setLoading(false);
                    setOtp(true);
                    SetStep(1);

                })
                .catch((Error) => {
                    setLoading(false);
                    toast.error("already used these credentials");
                    setResponseError(Error.response?.data?.message);
                });
        }
    };

    // -- Function to handle Otp verification
    const HandleOtpVerify = (e) => {

        e.preventDefault();
        setError({ ...error, otp: "" });
        if (e.target.value === "") {
            setError({ ...error, otp: "enter the otp" });
        } else {
            setLoading(true);
            instance
                .post("api/verifyphone_number", otpDetails)
                .then((response) => {
                    console.log(response.data, "verifyphone_number");

                    setPasswordToggle(true)
                    setLoading(false);
                    setOtp(false);
                    SetStep(2);



                })
                .catch((error) => {
                    setLoading(false);
                    setOtp(false);
                })
        }
    };



    // -- Function to handle resend Otp
    const HandleResendClick = () => {
        if (!IsTimerRunning) {
            SetTimer(60);
            SetIsTimerRunning(true);
            try {
                instance
                    .post("api/otpsent_mobile", {
                        phoneNumber: phoneNumber,
                    })
                    .then((response) => {
                        toast.success("OTP resent to your phone number");
                    })
                    .catch((err) => {
                        console.log(err);
                    })
            } catch (error) {
                console.log(error);
            }
        }
    };

    const handleNotPermission = (userId)=>{
        const notification = localStorage.getItem("pshdsadhgsa")
        console.log(Notification,"not inside api");
        console.log(userId,"user inside api");
        
        if(Notification){
            instance.post('api/update_notification_permision', { userId, notification } ).then((res)=>{
                console.log(res.data);
                
            }).catch((Err)=>{
                console.log(Err);
                
            })
        }
       return
    }

    const submitFinalStage = (e) => {
        e.preventDefault();
        console.log("clicked");

        console.log(username,
            phoneNumber,
            confirmPassword, 'datas');
        setResponseError("");

        // Validate password and confirm password
        if (!password || password.length < 8) {
            setError({ ...error, password: "Password must be at least 8 characters" });
            return;
        }
        if (password !== confirmPassword) {
            setError({ ...error, confirmPassword: "Passwords do not match" });
            return;
        }

        setLoading(true);



        instance

            .post("/api/registration_mobile_way", {
                username,
                phoneNumber,
                confirmPassword,
            })
            .then((response) => {
                console.log(response.data);
                setLoading(false);
                toast.success("Registration Successfull!");
                handleNotPermission(response.data.userData._id)
                // setPasswordToggle(false);
                // SetStep(0);
                if (response.data.userData.role === "superadmin" || response.data.userData.role === "admin") {
                    localStorage.setItem("AdminLogged", true);
                    localStorage.setItem("AdminToken", response.data.token);
                    SetAdmin(response.data.userData);
                    navigate("/admin");
                } else {
                    localStorage.setItem("logged", true);
                    localStorage.setItem("token", response.data.token);
                    localStorage.setItem("hasSignedUp", true)
                    SetUser(response.data.userData);
                    navigate('/');
                }

            })
            .catch((error) => {
                setLoading(false);
                toast.error(error.response?.data?.message || "Something went wrong");
                setResponseError(error.response?.data?.message);
            });
    };


    const handleGoogleLogin = () => {

        // window.location.href = "http://localhost:8080/api/auth/google"
        window.location.href = " https://api.dealnbuy.in/api/auth/google"
        //   window.location.href = "http://localhost:8080/api/auth/google"

    }

    console.log(privacyPermission,"permision--------------------");
    

    return (
        <div className={Style.form_wrapper}>
            <div className={Style.form_container}>
                <div className={Style.right_section}>
                    <div className={Style.img_wrapper}>
                        <img src="/Images/undraw.svg" alt="" />
                    </div>
                </div>

                {
                    passwordToggle ? (
                        <div className={Style.left_section}>
                            <h4 className={Style.Step_Status}>Step {Step} / 2</h4>
                            <h1>Enter Your Details</h1>
                            <p>
                                {" "}
                                We have sent you a One Time Password to your{" "}
                                <span> Phonenumber</span>{" "}
                            </p>
                            <form onSubmit={submitFinalStage}>

                                <div className={Style.input_div}>
                                    <div>
                                
                                        <label htmlFor="username">Enter Your Username</label>
                                        <div className={Style.input_Wrap}>
                                            <input
                                                type="text"
                                                placeholder="Username"
                                                required
                                                id="username"
                                                onChange={(e) => setUsername(e.target.value)}
                                            />
                                        </div>
                                        <p className={Style.error}>{error.username}</p>
                                    </div>
                                </div>

                                {/* Password Input Field */}
                                <div className={Style.input_div}>
                                    <div>
                                        <label htmlFor="password">Enter Your Password</label>
                                        <div className={Style.input_Wrap}>
                                            <input
                                                type={ShowPassword ? "text" : "password"}
                                                placeholder="Password"
                                                required
                                                id="password"
                                                onChange={(e) => password_validation(e)}
                                            />
                                            <span className={Style.eye_icon} onClick={togglePasswordVisibility}>
                                                {ShowPassword ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
                                            </span>
                                        </div>
                                        <p className={Style.error}>{error.password}</p>
                                    </div>
                                </div>

                                {/* Confirm Password Input Field */}
                                <div className={Style.input_div}>
                                    <div>
                                        <label htmlFor="Confirm_Password">Enter Your Confirm Password</label>
                                        <div className={Style.input_Wrap}>
                                            <input
                                                type={ShowConfirmPassword ? "text" : "password"}
                                                required
                                                placeholder="Confirm Password"
                                                id="Confirm_Password"
                                                onChange={(e) => confirmPassword_validation(e)}
                                            />
                                            <span className={Style.eye_icon} onClick={toggleConfirmPasswordVisibility}>
                                                {ShowConfirmPassword ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
                                            </span>
                                        </div>
                                        <p className={Style.error}>{error.confirmPassword}</p>
                                    </div>
                                </div>

                                {/* Submit Button */}
                                <button type="submit">
                                    {loading ? <LoadingSpin size="20px" direction="alternate" width="4px" /> : "Complete Registration"}
                                </button>
                            </form>


                        </div>


                    ) : otp ? (
                        <div className={Style.left_section}>
                            <h4 className={Style.Step_Status}>Step {Step} / 2</h4>
                            <h1>Lets Authenticate</h1>
                            <p>
                                {" "}
                                We have sent you a One Time Password to your Phonenumber{" "}
                            </p>
                            <form
                                onSubmit={(e) => {
                                    HandleOtpVerify(e);
                                }}
                            >
                                <div className={Style.input_div}>
                                    <div>
                                        <label htmlFor="OTP">Enter Your Otp here</label>
                                        <input
                                            type="tel"
                                            placeholder="One Time Password"
                                            id="OTP"
                                            value={otpDetails.otp}
                                            onChange={(e) => {
                                                otpHandler(e);
                                            }}
                                        />
                                    </div>
                                </div>
                                <button>
                                    {loading ? (
                                        <LoadingSpin size="20px" direction="alternate" width="4px" />
                                    ) : "Continue"}
                                </button>
                            </form>
                            <button
                                className={Style.resendBtn}
                                onClick={(e) => {
                                    HandleResendClick(e);
                                }}
                                disabled={IsTimerRunning}
                            >
                                {IsTimerRunning
                                    ? `Resend OTP in ${Timer}s`
                                    : "Resend One-Time Password"}
                            </button>
                            <p className={Style.error_para}>{error.otp}</p>
                        </div>
                    ) : (
                        <div className={Style.left_section}>
                            <div className={Style.login_Details}>
                                <h1>{t("Create Account")}</h1>
                                <p>{t("provideDetails")}</p>
                            </div>

                            <form
                                onSubmit={(e) => {
                                    submitHandler(e);
                                }}
                            >
                                <div className={Style.input_div}>

                                    <div>
                                        <label htmlFor="Phone Number">{t("phoneNumber")}</label>
                                        <input
                                            required
                                            type="tel"
                                            placeholder="Phone Number"
                                            id="phonenumber"
                                            maxLength="10"
                                            inputMode="numeric"
                                            pattern="[0-9]*"
                                            onChange={(e) => {
                                                phone_validation(e);
                                            }}
                                        />
                                        <p className={Style.error}>{error.phoneNumber}</p>
                                    </div>
                                </div>
                                <div>
                                    <p className={Style.terms}>
                                    <input type="checkbox" name="checkbox" value={privacyPermission} id="" onChange={()=>{setPrivacyPermission(!privacyPermission)}}/>

                                        {t("acceptTerms")}
                                        <Link
                                            to="/legal-and-privacy/terms&condition"
                                            className={Style.navigation}
                                        >
                                            <span>{t("termsOfUse")}</span>
                                        </Link>{" "}
                                        and
                                        <Link to="/legal-and-privacy" className={Style.navigation}>
                                            <span>{t("privacyPolicy")}</span>
                                        </Link>
                                    </p>
                                </div>
                                <div>
                                    <NotificationToggle />
                                </div>
                              
                                <button disabled={!privacyPermission}  style={{
    cursor: privacyPermission ? "pointer" : "not-allowed",
  }}>
                                    {loading ? (
                                        <LoadingSpin size="20px" direction="alternate" width="4px" />
                                    ) : (
                                        t("continue")
                                    )}
                                </button>
                                <p className={Style.error_para}>{responseError}</p>
                            </form>

                            <div className={Style.additional_options}>
                                <p>
                                    {t("alreadyHaveAccount")}
                                    <Link
                                        className={Style.navigation}
                                        onClick={() => {
                                            setLogin(false);
                                        }}
                                    >{t("login")}
                                    </Link>
                                </p>
                            </div>
                            <div>
                                <h1 style={{ fontFamily: "monospace", fontStyle: "bold", fontSize: "20px", width: "100%", textAlign: "center", color: "black", paddingTop: "10px" }}>OR</h1>
                            </div>
                            <div className={Style.google_auth}>
                                <Google />
                                <button onClick={handleGoogleLogin} className={Style.googleBtn}  disabled={!privacyPermission}  style={{
    cursor: privacyPermission ? "pointer" : "not-allowed",
  }}>Sign up via Google</button>
                            </div>
                        </div>
                    )
                }
            </div>

        </div>
    );
};

export default MobileSignup;
